// extracted by mini-css-extract-plugin
export var globe = "lang-picker-module--globe--hnwBL";
export var select = "lang-picker-module--select--zbK1K";
export var wrap = "lang-picker-module--wrap--S2XuL";